import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const theme = createTheme({

  typography: {
    allVariants: {
      color: "#F8FAFF",
    },
    ...rootTheme.typography,
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginTop: 5,
          color: "#fff",
          border: "1px solid rgba(0, 136, 245, 0.7);",
          width: "100%",
        },
      },
    },
  }
});
